import { Component, OnInit } from '@angular/core';
import { UserMerchantData } from "./../../../services/Common/common-function.service";
import { CommonFunctionService } from "./../../../services/Common/common-function.service";
import { environment } from 'src/environments/environment';
const _clone = (d) => JSON.parse(JSON.stringify(d));
import * as XLSX from 'xlsx';
import { Validators, FormControl } from "@angular/forms";
import { TransactionService } from 'src/app/services/transaction/transaction.service';
import { PayoutService } from 'src/app/services/payout.service';
@Component({
  selector: 'app-payoutbatches',
  templateUrl: './payoutbatches.component.html',
  styleUrls: ['./payoutbatches.component.scss']
})
export class PayoutbatchesComponent implements OnInit {
  Tourtransaction:any;
  getinfo:any;
  excelStatus: any;
  excelDataResponse =[];
  isreportsbtnActive: boolean = false;
  isStartDateGreaterthenEndDate : boolean = false;
  isCustomDateSelected: boolean = false;
  Fromdate1 :any;
  todate1 :any;
  PaymentType= new FormControl("", [Validators.required]);
  daterange = new FormControl("", [Validators.required]);
  Rfromdate: boolean = false;
  Dfiltering:boolean = true;
  Workclose= false;
  PayoutStep1 = false;
    PayoutStep2 = false;
    PayoutTour= true;
    tourDiv= false;
  Amount=new FormControl("", [Validators.required]);
  batchid=new FormControl("", [Validators.required]);
  todate=new FormControl("", [Validators.required]);
  fromdate = new FormControl("", [Validators.required]);
  transactionStatus = new FormControl("", [Validators.required]);
  Type= new FormControl("", [Validators.required]);
  amountcheck= new FormControl("", [Validators.required]);
  Range = [
    { text: "Today", value: "0" },
    { text: "Yesterday", value: "1" },
    { text: "current week", value: "2" },
    { text: "Last Week", value: "3" },
    { text: "This Month", value: "4" },
    { text: "Last Month", value: "5" },
    { text: "Custom Date Range", value: "6" }
  ];
  PaymentTypes = [
    { text: "Credit", value: "Credit" },
    { text: "Debit", value: "Debit" },
   

  ];

  symbol = [
    { text: "=", value: "=" },
    { text: "<", value: "<" },
    { text: ">", value: ">" },
    { text: "<=", value: "<=" },
    { text: ">=", value: ">=" },
    { text: "<>", value: "<>" },

];

   
  filtering:boolean=false;
  loggedinuseremail:any;
  MerchantKeyId:any;
  editing = {};
  row = [];
  BatchDetails = [];

  rowsFilter = [];
  rowsExp = [];
  rowsSort = [];
  temp = [];
  expanded: any = {};
  timeout: any;
  rowsSel = [];
  selected = [];
  constructor(private commonfunction: CommonFunctionService,private transactionservice: TransactionService,private service: PayoutService) { }

  ngOnInit() {
    this.getinfo=localStorage.getItem('SettingDetails')
    var Transaction=this.getinfo;
    let jsonObj: any = JSON.parse(this.getinfo);
    
    if(jsonObj !=null)
    {
   this.Tourtransaction=jsonObj.ProductKnowledgeGuide_ProductTourPayoutBatches;
   if(this.Tourtransaction ==false)
   {
     this.SkipTour();
   }
  }
    this.GetPayOutBatches();
  }

  filters() {
    this.filtering = !this.filtering;
  }

  GetPayOutBatches() {
    let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
    this.loggedinuseremail = this.commonfunction.getUserId();
    // this.loggedinuseremail=null;
    
  this.MerchantKeyId = merchantdata.MerchantKeyId;
  
    this.GetPayOutconatctdetailsList((data) => {
      // cache our list
      // this.temp = _clone(data);
      // this.row = _clone(data);;
      // this.rowsFilter = _clone(data);;
      // this.rowsExp = _clone(data);
      // this.rowsSort = _clone(data);
      // this.rowsSel = _clone(data);

    });
  }
  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
     if (charCode > 31 && (charCode < 48 || charCode > 57)) {
     return false;
     }
     return true;
      }
      

  GetPayOutconatctdetailsList(cb) {
      const req = new XMLHttpRequest();


      this.service.GetpayoutBatchList(this.MerchantKeyId).subscribe(data => {
      if(data !=null)
      {
        this.temp = _clone(data);
        this.row = _clone(data);;
        this.rowsFilter = _clone(data);;
        this.rowsExp = _clone(data);
        this.rowsSort = _clone(data);
        this.rowsSel = _clone(data);
      }
    });
      // req.open('GET', environment.GetpayoutBatchList + "?MerchantKeyId=" + this.MerchantKeyId);
     
      // req.onload = () => {
      //   cb(JSON.parse(req.response));
      // };
  
      // req.send();
    }


    search()
    {
        this.GetBatchesfilter((data) => {
            // cache our list
            // this.temp = _clone(data);
            // this.row = _clone(data);;
            // this.rowsFilter = _clone(data);;
            // this.rowsExp = _clone(data);
            // this.rowsSort = _clone(data);
            // this.rowsSel = _clone(data);

           

        });

      
    }

    close(){
      this.Workclose= false;
  }
// Nextstep() {
//     this.PayoutStep1 = false;
//     this.PayoutStep2 = false;
//     this.PayoutTour = false;
//     this.tourDiv= true;
  
//   }

  GetStarted() {
    this.PayoutStep2 = false; 
    this.PayoutTour = true;
    this.tourDiv = false;
    this.PayoutStep1 = false;
  }
  // backSubmit() {
  //   this.PayoutStep1 = true;
  //   this.PayoutStep2 = false;
  //   this.PayoutTour = false;
  //   this.tourDiv = true;
 
  // }
  GotoTour(){
    this.tourDiv = true; 
    this.PayoutTour = false;
    this.PayoutStep2 = false;
    this.PayoutStep1 = true;

  }
  SkipTour(){
    this.tourDiv = false; 
    this.PayoutTour = true;
    this.PayoutStep2 = false;
    this.PayoutStep1 = false;
  }
    checkRangeType()
    {
      var daterange=this.daterange.value;
      if(daterange=="Custom Date Range")
      {
       this.isCustomDateSelected = true;
       this.isStartDateGreaterthenEndDate = false;
          this.Rfromdate=true;
         this. Dfiltering=false;
         this.fromdate.setValue('');
         this.todate.setValue('');
         this.isreportsbtnActive = false;
      }
      else{
       this.isCustomDateSelected = false;
       this.isStartDateGreaterthenEndDate = false;
       this.Rfromdate=false;   
      }
    }

    checkDateRange()
  {
    if(this.fromdate.value != "" && this.todate.value!= "")
    {
      if(this.fromdate.value >this.todate.value)
      {
        this.isreportsbtnActive = false;
        this.isStartDateGreaterthenEndDate = true;
      }
      else{
        this.isreportsbtnActive = true;
        this.isStartDateGreaterthenEndDate = false;
      }
    }
    else{
      this.isreportsbtnActive = false;
      this.isStartDateGreaterthenEndDate = false;
    }
  }
  






  readAndExportToExcelData()
  {
    const workBook: XLSX.WorkBook = XLSX.utils.book_new();
  
   if(this.row.length>0)
   {
     this.row.forEach(element =>{
      
     var manageBatchArray = {'Batch Id':element.Id,'Transaction Type':element.TransactionType,'Total Transaction Count':element.TotalTransactionCount,'Batch NetAmount':element.BatchNetAmount,'BatchTime' :element.UpdatedDateTime}
     this.excelDataResponse.push(manageBatchArray);
    });

    const manageBatchWorkSheet = XLSX.utils.json_to_sheet(this.excelDataResponse,{header:['Batch Id', 'Transaction Type','Total Transaction Count','Batch NetAmount','BatchTime']});
    XLSX.utils.book_append_sheet(workBook, manageBatchWorkSheet, 'ManageBatch_tbl');
}
XLSX.writeFile(workBook,"Excel" + new Date().getTime() + '.xlsx');
this.excelDataResponse =[];

  }


















    selectedaterange()
    {
        var daterange=this.daterange.value;
       if(daterange=="Custom Date Range")
       {
        this.isCustomDateSelected = true;
        this.isStartDateGreaterthenEndDate = false;
           this.Rfromdate=true;
          this. Dfiltering=false;
       }
       else{
        this.isCustomDateSelected = false;
        this.isStartDateGreaterthenEndDate = false;
        this.Rfromdate=false;   
        this.search();
      
       }
    }

    GetBatchesfilter(cb) {
      var daterange=this.daterange.value;
      var PaymentType= this.PaymentType.value;
     var batchid=this.batchid.value;
     var Amount=this.Amount.value;
     var amountcompare=this.amountcheck.value;
     if(Amount=="")
     {
         Amount="0";
     }
     if(batchid=="")
     {
      batchid="0";
     }
      // this.Fromdate1 =new Date();this.fromdate.values;     
       // var todate=this.todate.value;     
        var transactionStatus=this.transactionStatus.value;
       if(daterange=="Today")
       {           
          this.Fromdate1=new Date().toISOString().slice(0,10); 
          this.todate1=new Date().toISOString().slice(0,10); 
          
       }  
     else if(daterange=="Yesterday")
       {
          const today =  new Date();
           const tomorrow =  new Date(today.setDate(today.getDate() - 1)).toISOString().slice(0,10); 
            this.Fromdate1=tomorrow;
            this.todate1= tomorrow;  
       }  
       else if(daterange=="current week")
       {
          const today =  new Date();
          const tomorrow =  new Date(today.setDate(today.getDay()));
        

          var current = new Date();      
          var weekstart = current.getDate() - current.getDay() +1;    
          var weekend = weekstart + 6;      
          this.Fromdate1 = new Date(current.setDate(weekstart)).toISOString().slice(0,10); 
          this.todate1 = new Date().toISOString().slice(0,10); 
       }  
       else if(daterange=="Last Week")
       {      
              var curr = new Date; 
               var first = curr.getDate() - curr.getDay() - 6; 
               var last = first + 6;
               this.Fromdate1 = new Date(curr.setDate(first)).toISOString().slice(0,10);
               this.todate1 = new Date(curr.setDate(last)).toISOString().slice(0,10);
            
       }  
       else if(daterange=="This Month")
       {
        const today =  new Date();
        const thismonth =  new Date(today.setDate(today.getMonth())).toISOString().slice(0,10); 
        //this.Fromdate1=thismonth;   
        this.Fromdate1= new Date(today.getFullYear(), today.getMonth(), 1).toDateString();
        this.todate1=new Date().toISOString().slice(0,10);   
             
       }  
       else if(daterange=="Last Month")
       {
              //  var date = new Date();                
              //  this.Fromdate1 = new Date(date.getFullYear(), date.getMonth() - 1, 1).toISOString().slice(0,10);
              //  this.todate1 = new Date(date.getFullYear(), date.getMonth() - 1 + 1, 0).toISOString().slice(0,10);
              var date = new Date();
              this.Fromdate1= new Date(date.getFullYear(), date.getMonth()-1, 1).toDateString();
              this.todate1 = new Date(date.getFullYear(), date.getMonth()-1 + 1, 0).toDateString();
       } 
       else if(daterange=="Custom Date Range")
       {
         
           this.Fromdate1=this.fromdate.value;
           this.todate1=this.todate.value;       
       }   
       else
       {
           this.Fromdate1=new Date().toISOString().slice(0,10); 
           this.todate1=new Date().toISOString().slice(0,10); 
       } 

      const req = new XMLHttpRequest();
      // req.open('GET',
      // environment.PayOutbatchesFilterdataurl+"?MerchantKeyId="+this.MerchantKeyId+"&fromdate="+this.Fromdate1+"&todate="+this.todate1
      // +"&PaymentType="+PaymentType+"&batchid="+batchid+"&Amount="+Amount+"&AmountCheck="+amountcompare);
      //  req.onload = () => {
      //      cb(JSON.parse(req.response));
      //  };
      
     // this.service.PayOutbatchesFilterdataurl(this.MerchantKeyId,this.Fromdate1,this.todate1,PaymentType,batchid,Amount,amountcompare).subscribe(data => {
        let form = {
          MerchantKeyId:this.MerchantKeyId,
          fromdate:this.Fromdate1, 
          todate:this.todate1,
          PaymentType:PaymentType,
          batchid:batchid,
          AmountCheck:amountcompare,
          Amount:Amount
          };
        this.service.PayOutbatchesFilterdataurl(form).subscribe(data => {
if(data !=null)
{
  this.temp = _clone(data);
  this.row = _clone(data);;
  this.rowsFilter = _clone(data);;
  this.rowsExp = _clone(data);
  this.rowsSort = _clone(data);
  this.rowsSel = _clone(data);
}
      });
      //  req.send();
   }

   ShowMeAgain()
   {
     var Type="Payout Batches";
     const merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
     this.transactionservice.UpdateManageTransactionSettings(merchantdata.MerchantKeyId,merchantdata.UserId,Type).subscribe(result => {
       if(result !=null)
       {
         localStorage.removeItem('SettingDetails');
         this.transactionservice.GetUserPreferenceSettings(merchantdata.MerchantKeyId,merchantdata.UserId).subscribe(result => {
           if(result !=null)
           {
            localStorage.setItem("SettingDetails",JSON.stringify(result));
            window.location.reload();
           }
         });
       }
     });
   }
   resetForm(){

    this.daterange.reset('');
    this.PaymentType.reset(''); 
    this.Amount.reset(''); 
    this.amountcheck.reset('');
    this.batchid.reset('');
    this.row=[];
    
  
   
  
  }

}
